import {User} from '../../classes/user.class';
import {Role} from '../../classes/role.class';

export class ConditionalFunctions {


}
